import * as React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { StepConnector, stepConnectorClasses, styled } from "@mui/material";
import PropTypes from 'prop-types';
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 7px)',
    right: 'calc(50% + 7px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#03589C',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#03589C',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 1,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    background: `url(${publicRuntimeConfig.basePath}/step-icon-completed.svg) no-repeat center`,
  }),
  '& .QontoStepIcon-circle.QontoStepIcon-completedIcon': {
    zIndex: 1,
    fontSize: 18,
    background: `url(${publicRuntimeConfig.basePath}/step-icon-completed.svg) no-repeat center`,
  },
  '& .QontoStepIcon-circle': {
    width: 14,
    height: 14,
    borderRadius: '50%',
    background: !ownerState.active ? `url(${publicRuntimeConfig.basePath}/step-icon-not-completed.svg) no-repeat center` : 'none',
  },
}));

const StyledStepLabel = styled(StepLabel)(() => ({
  ['& .MuiStepLabel-label']: {
    fontFamily: 'MontserratBold',
    fontSize: '10px',
    lineHeight: '12px',
    textTransform: 'uppercase',
  },
  ['& .MuiStepLabel-label.Mui-active']: {
    color: '#03589C',
  },
  ['& .MuiStepLabel-label.Mui-completed']: {
    color: '#03589C',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <div className="QontoStepIcon-circle QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};


export default function ProductStep({activeStep, steps}) {
  return (
          <Stepper activeStep={activeStep} alternativeLabel connector={<QontoConnector />}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              return (
                <Step key={label} {...stepProps}>
                  <StyledStepLabel {...labelProps} StepIconComponent={QontoStepIcon}>{label}</StyledStepLabel>
                </Step>
              );
            })}
          </Stepper>
  );
}
